
import {unauthApi} from './unauth'


export const getReviewByIdApi = unauthApi.injectEndpoints({
  endpoints: (builder) => ({
    getReviewById: builder.query({
      providesTags: (result, error, {reviewId}) => [{ type: 'reviewDetails', id: reviewId }],      
      query: ({reviewId, authType, token}) => `/v2/sp/review/${reviewId}?authType=${authType}&&token=${token}`,
    }),
    

  }),
  overrideExisting: false,
})

export const { useGetReviewByIdQuery, usePrefetch } = getReviewByIdApi





